import ko from 'knockout';
import _ from 'lodash';

ko.bindingHandlers.reset = {
	init: (element, valueAccessor, allBindings, viewModel, bindingContext) => {
		if (!_.isFunction(valueAccessor())) {
			throw new Error('The value for a reset binding must be a function');
		}

		ko.utils.registerEventHandler(element, 'reset', event => {
			const callback = valueAccessor();
			let result = null;

			try {
				result = callback.call(bindingContext['$data'], element);
			} finally {

				if (result !== true) {
					if (event.preventDefault) {
						event.preventDefault();

					} else {
						event.returnValue = false;
					}
				}
			}
		});
	},
};
